import { createAsyncThunk } from '@reduxjs/toolkit';
import { _appointmentUrls } from '@custom/Utils/constants/apiUrls';

const getAIStudiesApi = createAsyncThunk(
  'getAIStudiesApi',
  async (payload: { hospitalId: string; hospitalCode: string }, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      const url = _appointmentUrls.getAIStudies;

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error('Failed to get AI Studies');
      }

      return await response.json();
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to get AI Studies');
    }
  }
);

export default getAIStudiesApi;
